// src/utils/domainConfig.js
export const getDomainConfig = () => {
  const hostname = window.location.hostname;
  const port = window.location.port;
  
  console.log('Current hostname:', hostname);
  console.log('Current port:', port);
  
  // Map ports to their route configurations (for local Docker testing)
  const portConfigs = {
    '3405': {
      name: 'luxottica',
      routes: ['luxottica', 'luxotticaAuth'],
      basePath: '/'
    },
    '3406': {
      name: 'iconic',
      routes: ['iconic', 'iconicAuth'],
      basePath: '/'
    },
    '3019': {
      name: 'main',
      routes: ['main', 'admin', 'auth'],
      basePath: '/'
    }
  };
  
  // Map domains to their route configurations (for production)
  const domainConfigs = {
    'luxottica.parallelia.com': {
      name: 'luxottica',
      routes: ['luxottica', 'luxotticaAuth'],
      basePath: '/'
    },
    'iconic.parallelia.com': {
      name: 'iconic',
      routes: ['iconic', 'iconicAuth'],
      basePath: '/'
    },
    'admin.horoboro.com': {
      name: 'main',
      routes: ['main', 'admin', 'auth'],
      basePath: '/'
    },
    'localhost': {
      name: 'all',
      routes: ['main', 'admin', 'auth', 'luxottica', 'luxotticaAuth', 'iconic', 'iconicAuth'],
      basePath: '/'
    }
  };
  
  // Check port first (for direct Docker access like localhost:3405)
  if (port && portConfigs[port]) {
    console.log('Matched by port:', portConfigs[port]);
    return portConfigs[port];
  }
  
  // Then check exact hostname match
  if (domainConfigs[hostname]) {
    console.log('Matched by exact hostname:', domainConfigs[hostname]);
    return domainConfigs[hostname];
  }
  
  // Fallback: check if hostname contains any of the domain keys
  const matchedDomain = Object.keys(domainConfigs).find(domain => 
    hostname.includes(domain)
  );
  
  if (matchedDomain) {
    console.log('Matched by domain substring:', domainConfigs[matchedDomain]);
    return domainConfigs[matchedDomain];
  }
  
  // Default fallback - show all routes
  console.log('No match found, using default (all routes)');
  return {
    name: 'all',
    routes: ['main', 'admin', 'auth', 'luxottica', 'luxotticaAuth', 'iconic', 'iconicAuth'],
    basePath: '/'
  };
};